module.exports = __webpack_public_path__ + "static/media/filamento-tungstenio.f1cec34f.PNG";